import { Component, Input, OnInit } from '@angular/core';

interface Item{
  childOf: string,
  data: object
}

@Component({
  selector: 'side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.css']
})
export class SideBarComponent {

 public barUnTouched = true;
 public collapsed = true;
 
  @Input() public data: Array<object>;

  selectRow(newRow, parentData, parent) {
    //branch is touched now.
    this.barUnTouched = false;
    //unselect all (frontend)
    this.unselect(parentData);
    //set currently clikced row to selected (frontend)
    newRow.selected = true;
    if(newRow.unselectsChildOnClick){
      this.data.map( (item:Item) =>{
        if(typeof item.childOf !== 'undefined' && item.childOf === parent.type){
          this.unselect(item.data);
        }
      })
    }
  }
  unselect(item){
    item.map(row => {
      if (typeof row.selected !== 'undefined') {
        row.selected = false;
      }
    })
  }

  collapse(){
    if(window.window.innerWidth < 700){
      this.collapsed = !this.collapsed;
    }
  }
}
 


// WEBPACK FOOTER //
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/side-bar/side-bar.component.ts